
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9.355 8.976"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.681 0c.26 0 .466.113.621.34l.063.104.972 2.16 2.352.264.115.024a.697.697 0 01.51.48.713.713 0 01-.125.704l-.08.088L7.357 5.76l.48 2.316.012.11a.762.762 0 01-.168.508.69.69 0 01-.576.282.77.77 0 01-.259-.06l-.113-.048-2.052-1.164-2.064 1.164-.112.047c-.258.092-.489.064-.692-.083-.23-.161-.336-.374-.316-.64l.016-.116.48-2.328L.241 4.164c-.224-.24-.292-.504-.204-.792a.722.722 0 01.519-.49l.117-.026 2.34-.252.984-2.16.066-.104c.16-.227.366-.34.618-.34z"}})])
          )
        }
      }
    